import classNames from 'classnames';
import { AnimatedDigit } from '~/components/Animated/Digit/AnimatedDigit';
import { format } from '~/components/Util/number';
import styles from './AnimatedNumber.module.scss';

export type AnimatedNumberProps = {
  className?: string;
  value: number | string;
  formatter?: (value?: number | string) => string;
  duration?: number;
};

export const AnimatedNumber = ({
  className,
  value = 0,
  formatter = format,
  duration = 1000,
}: AnimatedNumberProps) => {
  const formatted = formatter(value);
  const items = formatted.split('');
  const dotIndex = formatted.indexOf('.');

  return (
    <div className={classNames(styles.root, className)}>
      {items.map((char, i) => {
        const key = i - dotIndex;
        const delay = duration * (1 - i / formatted.length);
        const number = parseInt(char, 10);
        const isNumber = !isNaN(number);
        return isNumber ? (
          <AnimatedDigit key={key} value={number} delay={delay} />
        ) : (
          <div key={`${char}-${i}`} className={styles.separator}>
            {char}
          </div>
        );
      })}
    </div>
  );
};
